module.exports = __webpack_public_path__ + "img/box01_02.0dad948a.jpg";